var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 12.5,
    stroke: "#E1E6EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5598 8.31522L15.9348 12.6902C15.9755 12.7309 16.0077 12.7791 16.0297 12.8322C16.0518 12.8853 16.0631 12.9423 16.0631 12.9998C16.0631 13.0573 16.0518 13.1142 16.0297 13.1673C16.0077 13.2204 15.9755 13.2687 15.9348 13.3093L11.5598 17.6843C11.4777 17.7664 11.3663 17.8125 11.2502 17.8125C11.1341 17.8125 11.0228 17.7664 10.9407 17.6843C10.8586 17.6022 10.8125 17.4909 10.8125 17.3748C10.8125 17.2587 10.8586 17.1473 10.9407 17.0652L15.0067 12.9998L10.9407 8.93429C10.9001 8.89364 10.8678 8.84538 10.8458 8.79227C10.8238 8.73916 10.8125 8.68224 10.8125 8.62476C10.8125 8.56727 10.8238 8.51035 10.8458 8.45724C10.8678 8.40413 10.9001 8.35587 10.9407 8.31522C10.9814 8.27458 11.0296 8.24233 11.0827 8.22033C11.1358 8.19834 11.1928 8.18701 11.2502 8.18701C11.3077 8.18701 11.3647 8.19834 11.4178 8.22033C11.4709 8.24233 11.5191 8.27458 11.5598 8.31522Z",
    fill: "#334155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForward);
export default __webpack_public_path__ + "static/media/Arrow Forward.43a0511ed4d91ea8104cead2f339e33c.svg";
export { ForwardRef as ReactComponent };